import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "withMask", "spacing", "style", "compact"];
import * as React from 'react';
import classNames from 'classnames';
var AvatarGroup = function AvatarGroup(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$withMask = _ref.withMask,
    withMask = _ref$withMask === void 0 ? false : _ref$withMask,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? -4 : _ref$spacing,
    style = _ref.style,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var childrenWithProps = React.Children.map(children, function (child, index) {
    var _extends2;
    var isFirstAvatar = index === 0;
    return /*#__PURE__*/React.cloneElement(child, {
      mask: withMask && (isFirstAvatar ? '' : 'mask'),
      key: "avatar-key-" + index,
      style: _extends((_extends2 = {}, _extends2['marginLeft'] = spacing, _extends2), child.props.style),
      compact: compact
    });
  });
  var flexStyle = {
    display: 'inline-flex'
  };

  // const numOfChildren = childrenWithProps.length;
  // if (max && max < numOfChildren) {
  //   let childrenShow = childrenWithProps.slice(0, max);
  //   const excess = numOfChildren - max;
  //   childrenShow.unshift(<Avatar label={`+${excess}`} />);
  //   return (
  //     <div role="group" className={classNames('ap-avatar-group', className)} style={{ ...flexStyle, ...style }} {...rest}>
  //       {childrenShow}
  //     </div>
  //   );
  // }

  return /*#__PURE__*/React.createElement("div", _extends({
    role: "group",
    className: classNames('ap-avatar-group', className),
    style: _extends({}, flexStyle, style)
  }, rest), childrenWithProps);
};
AvatarGroup.displayName = 'AvatarGroup';
export default AvatarGroup;